import React from 'react';
import PropTypes from 'prop-types';
import Isvg from 'react-inlinesvg';

import Dot from 'components/Dot/Dot';
import Message from 'components/Message';

import { ICONS } from 'constants/icons';

import { bem } from 'helpers/class-name';

import { getPricingStatusView, STEP_STATE } from './pricingStatusStepper.helpers';
import { messages } from './PricingStatusStepper.messages';

import './PricingStatusStepper.scss';

const { block, element } = bem('pricing-status-stepper');

const STEP_ICON = {
  [STEP_STATE.DONE]: ICONS.checkmarkInCircle,
  [STEP_STATE.CURRENT]: ICONS.clock,
  [STEP_STATE.FAILED]: ICONS.crossInCircle,
};

// Timeline of a service's pricing (retail-rate-request) review, shown on the
// edit pages once a request exists. Renders nothing when there's no request.
const PricingStatusStepper = ({ retailRateRequest }) => {
  const view = getPricingStatusView(retailRateRequest);
  if (!view) return null;

  const { steps, statusLabel, statusColor } = view;

  return (
    <div className={block()} data-cypress="pricing-status-stepper">
      <div className={element('status-row')}>
        <Dot color={statusColor} />
        <Message as="span" message={statusLabel} className={element('status-label')} />
      </div>

      <ol className={element('steps')}>
        {steps.map((step, index) => {
          const isLast = index === steps.length - 1;
          return (
            <li
              key={step.titleMessage.id}
              className={element('step', { [step.state]: true, last: isLast })}
              data-cypress={`pricing-status-step-${step.state}`}>
              <div className={element('step-marker')}>
                {step.state === STEP_STATE.UPCOMING ? (
                  <span className={element('step-circle')} />
                ) : (
                  <Isvg src={STEP_ICON[step.state]} className={element('step-icon')} />
                )}
                {!isLast && <span className={element('step-connector')} />}
              </div>

              <div className={element('step-content')}>
                <Message as="p" message={step.titleMessage} className={element('step-title')} />
                {step.subtitleMessage && (
                  <Message as="p" message={step.subtitleMessage} className={element('step-subtitle')} />
                )}
              </div>
            </li>
          );
        })}
      </ol>
    </div>
  );
};

const statusPropType = PropTypes.oneOfType([PropTypes.number, PropTypes.string]);

PricingStatusStepper.propTypes = {
  retailRateRequest: PropTypes.shape({
    status: statusPropType,
    status_reason: statusPropType,
    statusReason: statusPropType,
  }),
};

PricingStatusStepper.messages = messages;

export default PricingStatusStepper;
